jQuery(document).ready(($) => {

    const $favoritesNavs = $('.favorites-pages .nav-arrow');
    const $favoritesPages = $('.favorites-pages');

    const $userPosts = $('.sport1-plus-mobile .user-posts');

    if ($userPosts.length > 0) {
        $userPosts.slick({
            variableWidth: true,
            rtl: true,
            infinite: false,
            arrows: false
        });
    }


    if ($favoritesNavs.length) {

        $favoritesNavs.on('click', function () {

            let scrollBy = $favoritesPages.outerWidth() * -1;
            if ($(this).hasClass('nav-arrow-prev')) {
                scrollBy *= -1;
            }

            $favoritesPages.get(0).scrollBy({left: scrollBy, behavior: 'smooth'})
        })
    }

    $favoritesPages.on('scroll', function () {
        let railLeft = $(this).width() - (this.scrollWidth - this.scrollLeft);

        $('.nav-arrow-prev', $(this)).css('right', `${Math.abs(railLeft)}px`);
        $('.nav-arrow-next', $(this)).css('left', `${railLeft}px`);


        let scrollLeft = $(this).scrollLeft();
        let width = $(this).width();

        if (scrollLeft + width < this.scrollWidth) {
            $('.nav-arrow-prev', $(this)).addClass('active');
        } else {
            $('.nav-arrow-prev', $(this)).removeClass('active');
        }

        if (scrollLeft === 0) {
            $('.nav-arrow-next', $(this)).removeClass('active');
        } else {
            $('.nav-arrow-next', $(this)).addClass('active');
        }
    });

});